<template>
  <div id="gradients">
    <svg v-for="stop in stops" :key="stop.id" width="0" height="0">
      <defs>
        <linearGradient :id="stop.id" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stop-color="black" stop-opacity="1" />
          <stop offset="1" :stop-color="stop.color" stop-opacity="1" />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
// Shared SVG paint sources — other components fill shapes with
// `fill: url(#demon)` / `url(#townsfolk)` / `url(#default)` rather than a
// flat colour, so the gradients need to exist exactly once, mounted here.
export default {
  data() {
    return {
      stops: [
        { id: "demon", color: "#ce0100" },
        { id: "townsfolk", color: "#1f65ff" },
        { id: "default", color: "hsl(0, 0%, 30%)" }
      ]
    };
  }
};
</script>

<style scoped>
/* invisible, weightless — must NOT be display: none, or some browsers stop
   resolving url(#id) paint references against them */
svg {
  position: absolute;
  width: 0;
  height: 0;
  z-index: -1;
}
</style>
